import { render, staticRenderFns } from "./HostedFilesPane.vue?vue&type=template&id=5be1da66&scoped=true&"
import script from "./HostedFilesPane.vue?vue&type=script&lang=js&"
export * from "./HostedFilesPane.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be1da66",
  null
  
)

export default component.exports